
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import * as moment from 'moment';
export default {
  data: function () {
    return {
      bookmark: false,
      soothers: {},
      preventSave: false,
      hasSoothers: true
    };
  },
  methods: {
    openHelpSheet: function (title, text) {
      var self = this;
      self.$$('#help-title')[0].textContent = title;
      self.$$('#help-text')[0].textContent = text;
      self.$app.sheet.open('.help-sheet');
    },
    pillarPopup: function () {
      var self = this;
      let today = moment($$('#entry-date')[0].value);
      let progressDays = today.diff(moment(self.$app.data.settings.programStartDate), 'days');
      let pillarNumber = Math.ceil(progressDays / 31);
      let pillar = self.$app.data.pillars[pillarNumber];
      let pillarTitle = `Pillar ${pillarNumber} "${pillar['title']}"`;
      $$('.pillar-title')[0].textContent = pillarTitle;
      $$('.pillar-text')[0].innerHTML = pillar['text'].replace(/\n/g, '<br>');
      self.popPillar = self.$app.popup.create({
        el: '.popup-pillar'
      });
      self.popPillar.open();
    },
    pillarClose: function () {
      // console.log('close pillar popup');
      this.popPillar.close();
    },
    toggleBookmark: function () {
      this.bookmark = !this.bookmark;
      this.$setState();
    },
    deleteEntry: function () {
      let self = this;
      if (!self.uid) {
        return;
      }
      self.$app.dialog.confirm('Are you sure you want to delete this entry? This cannot be undone.', 'Delete Entry', function () {
        db.collection('entries').doc(self.uid).delete().then(function () {
          console.log('Entry deleted successfully');
          self.preventSave = true;
          self.$f7router.back();
        }).catch(function (error) {
          console.error('Error deleting entry:', error);
          self.$app.dialog.alert('Failed to delete entry. Please try again.', 'Error');
        });
      });
    },
    promptForSoothers: function (page) {
      let self = this;
      if (self.sootherDialog) {
        return;
      }
      self.sootherDialog = self.$app.dialog.create({
        title: 'Add Soothers First',
        text: '<p>Daily entries rely on your personal soothers&mdash;short spiritual, physical, emotional, and social activities that keep you grounded (for example: pray, morning walk, deep-breathing, call a friend).</p>' + '<p>Please open Settings and add at least one soother in each category before logging a new entry.</p>',
        buttons: [{
          text: 'Go to Settings',
          bold: true,
          onClick: function () {
            self.preventSave = true;
            page.router.back({
              force: true
            });
            setTimeout(function () {
              if (page.app.tab && page.app.tab.show) {
                page.app.tab.show('#view-settings');
              }
            }, 300);
          }
        }],
        closeByBackdropClick: false,
        closeOnEscape: false,
        cssClass: 'soother-required-dialog',
        on: {
          closed: function () {
            self.sootherDialog = null;
          }
        }
      });
      self.sootherDialog.open();
    },
    toggle: function (val) {
      var self = this;
      let $toggleButton = self.$$(`#toggle-button-${val}`);
      $toggleButton.toggleClass('button-active');
      self.setPoints();
    },
    updateSober: function () {
      let daysSober = $$('#days-sober')[0].value;
      if (!daysSober) {
        daysSober = '?';
      }
      $$('#bottom-days-sober')[0].textContent = daysSober;
    },
    setPoints: function () {
      var self = this;
      let points = 0;
      $$('.soother').forEach(function (s) {
        if (s.value.length > 0) {
          points += 1;
        }
      });
      self.$$('.cb-pillar').forEach(function (pillar) {
        if (pillar.checked) {
          points += 1;
        }
      });
      self.$$('.point-button').forEach(function (btn) {
        if (btn.classList.contains('button-active')) {
          points += parseInt(btn.dataset.points);
        }
      });
      if ($$('#homework')[0].checked) {
        points += 2;
      }
      points += parseInt($$('#sobriety-slider')[0].value);
      let $todaysPoints = $$('#todays-points')[0];
      $todaysPoints.textContent = points;
      $todaysPoints.classList.remove('text-color-red', 'text-color-green');
      if (points < 0) {
        $todaysPoints.classList.add('text-color-red');
      }
      if (points > 18) {
        $todaysPoints.classList.add('text-color-green');
      }
    }
  },
  on: {
    pageInit: function (e, page) {
      let self = this;
      self.uid = this.$route.query.uid;
      self.preventSave = self.uid ? false : true;
      self.hasSoothers = !!self.uid;
      self.soothers = {
        spiritual: [],
        physical: [],
        emotional: [],
        social: []
      };
      if (self.uid) {
        $$('#done-link')[0].style.display = 'none';
        $$('#delete-button-block')[0].style.display = '';
        db.collection('entries').doc(self.uid).get().then(doc => {
          if (doc.exists) {
            self.data = doc.data();
            self.$setState(self.data);
            self.$app.input.resizeTextarea($$('#sobriety'));
            self.$app.input.resizeTextarea($$('#soothing'));
            self.$app.input.resizeTextarea($$('#high-risks'));

            // not sure why this only works with a timeout :(
            self.$app.smartSelect.get('.smart-select-spiritual').setValue(self.data.soothingSpiritual);
            self.$app.smartSelect.get('.smart-select-physical').setValue(self.data.soothingPhysical);
            self.$app.smartSelect.get('.smart-select-emotional').setValue(self.data.soothingEmotional);
            self.$app.smartSelect.get('.smart-select-social').setValue(self.data.soothingSocial);
            setTimeout(() => {
              self.$app.smartSelect.get('.smart-select-spiritual').setValue(self.data.soothingSpiritual);
              self.$app.smartSelect.get('.smart-select-physical').setValue(self.data.soothingPhysical);
              self.$app.smartSelect.get('.smart-select-emotional').setValue(self.data.soothingEmotional);
              self.$app.smartSelect.get('.smart-select-social').setValue(self.data.soothingSocial);

              // toggle buttons
              if (self.data.therapyGroup) {
                $$('#toggle-button-group').addClass('button-active');
              }
              if (self.data.therapyIndividual) {
                $$('#toggle-button-individual').addClass('button-active');
              }
              if (self.data.ao) {
                $$('#toggle-button-ao').addClass('button-active');
              }
              if (self.data.mb) {
                $$('#toggle-button-mb').addClass('button-active');
              }
              self.$app.range.setValue('.sobriety-slider', self.data.sobrietyPoints);
              self.updateSober();
              self.setPoints();
            }, 100);
            self.updateSober();
            var calendarModal = page.app.calendar.create({
              inputEl: '#entry-date',
              openIn: 'customModal',
              header: true,
              footer: true,
              dateFormat: 'DD, MM dd, yyyy',
              disabled: {
                from: new Date()
              },
              value: [moment(self.data.date)]
            });
          } else {
            // doc.data() will be undefined in this case
            console.error(`No document for ${self.uid}`);
          }
        }).catch(err => {
          console.error(`Error getting document: ${err}`);
        });
      } else {
        $$('#delete-button-block')[0].style.display = 'none';
        try {
          let entryDate = this.$route.params.date;
          if (entryDate === 'new') {
            entryDate = new Date();
            $$('#back-link')[0].style.display = 'none';
          } else {
            entryDate = moment(entryDate);
            $$('#done-link')[0].style.display = 'none';
          }
          var calendarModal = page.app.calendar.create({
            inputEl: '#entry-date',
            openIn: 'customModal',
            header: true,
            footer: true,
            dateFormat: 'DD, MM dd, yyyy',
            disabled: {
              from: new Date()
            },
            value: [entryDate]
          });
        } catch (e) {}
      }
      self.$app.authPromise.then(() => {
        db.collection('soothers').where('userId', '==', self.$app.data.user.uid).orderBy('order').get().then(function (querySnapshot) {
          self.soothers = {
            spiritual: [],
            physical: [],
            emotional: [],
            social: []
          };
          let total = 0;
          querySnapshot.forEach(function (doc) {
            let soother = doc.data();
            soother.uid = doc.id;
            if (!self.soothers[soother.type]) {
              self.soothers[soother.type] = [];
            }
            self.soothers[soother.type].push(soother);
            total += 1;
          });
          self.$setState({
            soothers: self.soothers
          });
          self.hasSoothers = total > 0;
          if (!self.uid) {
            self.preventSave = !self.hasSoothers;
            if (!self.hasSoothers) {
              self.promptForSoothers(page);
            }
          }
        }).catch(function (error) {
          console.error('Error loading soothers', error);
          if (!self.uid) {
            self.preventSave = true;
            self.promptForSoothers(page);
          }
        });
      });
    },
    pageAfterIn: function (e, page) {
      page.app.toolbar.hide('.toolbar');
    },
    pageBeforeOut: function (e, page) {
      let self = this;
      if (self.preventSave) {
        return;
      }
      let activeClass = 'button-active';
      let data = {
        userId: page.app.data.user.uid,
        date: moment($$('#entry-date')[0].value).format('YYYY-MM-DD'),
        daysSober: parseInt($$('#days-sober')[0].value),
        sobriety: $$('#sobriety')[0].value,
        soothing: $$('#soothing')[0].value,
        soothingSpiritual: $$('#soothing-spiritual')[0].value,
        soothingPhysical: $$('#soothing-physical')[0].value,
        soothingEmotional: $$('#soothing-emotional')[0].value,
        soothingSocial: $$('#soothing-social')[0].value,
        highRisks: $$('#high-risks')[0].value,
        pillar1: $$('#pillar1')[0].checked,
        pillar2: $$('#pillar2')[0].checked,
        pillar3: $$('#pillar3')[0].checked,
        therapyIndividual: $$('#toggle-button-individual')[0].classList.contains(activeClass),
        therapyGroup: $$('#toggle-button-group')[0].classList.contains(activeClass),
        homework: $$('#homework')[0].checked,
        sobrietyPoints: parseInt($$('#sobriety-slider')[0].value),
        mb: $$('#toggle-button-mb')[0].classList.contains(activeClass),
        ao: $$('#toggle-button-ao')[0].classList.contains(activeClass),
        points: parseInt($$('#todays-points')[0].textContent),
        snippet: $$('#sobriety')[0].value,
        bookmark: this.bookmark
      };
      if (isNaN(data.daysSober)) {
        data.daysSober = null;
      }

      // console.log;
      if (self.uid === undefined) {
        // Check if entry already exists for this date
        db.collection('entries').where('userId', '==', data.userId).where('date', '==', data.date).get().then(function (querySnapshot) {
          if (!querySnapshot.empty) {
            // Entry already exists for this date
            page.app.dialog.alert('An entry already exists for this date. Please edit the existing entry instead.', 'Duplicate Entry');
          } else {
            // No duplicate, safe to add
            db.collection('entries').add(data).then(function (docRef) {
              console.log('Document written with ID: ', docRef.id);
              if (page.route.path === '/entry/new/') {
                page.app.data.newEntries.push(data);
              }
            }).catch(function (error) {
              console.error('Error adding document: ', error);
            });
          }
        }).catch(function (error) {
          console.error('Error checking for duplicate entry: ', error);
        });
      } else {
        // console.log('TODO: update record', self.uid);
        // console.log(data);
        db.collection('entries').doc(self.uid).set(data).then(function () {
          // console.log('Document successfully written!');
        }).catch(function (error) {
          console.error('Error writing document: ', error);
        });
      }
    }
  },
  id: 'ff1d247747',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back" id="back-link">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">\n          <input type="text" id="entry-date" value="???" readonly="readonly" />\n        </div>\n        <div class="right">\n          <a href="/" class="link" data-animate="false" id="done-link">Done</a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content">\n      <div class="block-title">\n        Sobriety\n        <span\n          class="badge"\n          id="sobriety-help"\n          @click="openHelpSheet(\'Sobriety\', \'In this section you write about how your sobriety went on this day and what you did to achieve sobriety. You may also write about how you struggled and what you will do differently the next day.\')"\n        >\n          ?\n        </span>\n        <span class="float-right" @click="toggleBookmark()">\n          <i class="icon f7-icons if-not-md">bookmark';
      r += Template7Helpers.if.call(ctx_1, ctx_1.bookmark, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n          <i class="icon material-icons if-md">bookmark';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.bookmark, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_border';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n        </span>\n      </div>\n      <div class="list inline-labels no-hairlines-md">\n        <ul>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-title item-label">Days Sober</div>\n              <div class="item-input-wrap">\n                <input\n                  type="text"\n                  placeholder="#"\n                  id="days-sober"\n                  @change="updateSober()"\n                  value="';
      r += c(ctx_1.daysSober, ctx_1);
      r += '"\n                />\n                <span class="input-clear-button"></span>\n              </div>\n            </div>\n          </li>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-input-wrap">\n                <textarea class="resizable" placeholder="How my sobriety went..." id="sobriety">\n';
      r += c(ctx_1.sobriety, ctx_1);
      r += '</textarea\n                >\n              </div>\n            </div>\n          </li>\n        </ul>\n      </div>\n\n      <div class="block-title">\n        Soothing\n        <span\n          class="badge"\n          @click="openHelpSheet(\'Soothing\', \'In this section yo write about what you did to effectively soothe and how it helped you. You may also write about how you could be more efective in soothing the next day.\')"\n        >\n          ?\n        </span>\n      </div>\n\n      <div class="list">\n        <ul>\n          <li>\n            <a\n              class="item-link smart-select smart-select-init smart-select-spiritual"\n              data-open-in="popover"\n            >\n              <select\n                name="spiritual"\n                multiple\n                class="soother"\n                id="soothing-spiritual"\n                @change="setPoints()"\n              >\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.soothers.spiritual, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <option value="';
          r += c(ctx_2.value, ctx_2);
          r += '">';
          r += c(ctx_2.value, ctx_2);
          r += '</option>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </select>\n              <div class="item-content">\n                <div class="item-inner">\n                  <div class="item-title">Spiritual</div>\n                </div>\n              </div>\n            </a>\n          </li>\n          <li>\n            <a\n              class="item-link smart-select smart-select-init smart-select-physical"\n              data-open-in="popover"\n            >\n              <select\n                name="physical"\n                multiple\n                class="soother"\n                id="soothing-physical"\n                @change="setPoints()"\n              >\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.soothers.physical, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <option value="';
          r += c(ctx_2.value, ctx_2);
          r += '">';
          r += c(ctx_2.value, ctx_2);
          r += '</option>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </select>\n              <div class="item-content">\n                <div class="item-inner">\n                  <div class="item-title">Physical</div>\n                </div>\n              </div>\n            </a>\n          </li>\n          <li>\n            <a\n              class="item-link smart-select smart-select-init smart-select-emotional"\n              data-open-in="popover"\n            >\n              <select\n                name="emotional"\n                multiple\n                class="soother"\n                id="soothing-emotional"\n                @change="setPoints()"\n              >\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.soothers.emotional, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <option value="';
          r += c(ctx_2.value, ctx_2);
          r += '">';
          r += c(ctx_2.value, ctx_2);
          r += '</option>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </select>\n              <div class="item-content">\n                <div class="item-inner">\n                  <div class="item-title">Emotional</div>\n                </div>\n              </div>\n            </a>\n          </li>\n          <li>\n            <a\n              class="item-link smart-select smart-select-init smart-select-social"\n              data-open-in="popover"\n            >\n              <select\n                name="social"\n                multiple\n                class="soother"\n                id="soothing-social"\n                @change="setPoints()"\n              >\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.soothers.social, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <option value="';
          r += c(ctx_2.value, ctx_2);
          r += '">';
          r += c(ctx_2.value, ctx_2);
          r += '</option>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </select>\n              <div class="item-content">\n                <div class="item-inner">\n                  <div class="item-title">Social</div>\n                </div>\n              </div>\n            </a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="list inline-labels no-hairlines-md">\n        <ul>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-input-wrap">\n                <textarea\n                  class="resizable"\n                  placeholder="Additional thoughts and notes..."\n                  id="soothing"\n                >\n';
      r += c(ctx_1.soothing, ctx_1);
      r += '</textarea\n                >\n              </div>\n            </div>\n          </li>\n        </ul>\n      </div>\n\n      <div class="block-title">\n        High Risks\n        <span\n          class="badge"\n          @click="openHelpSheet(\'High Risks\', \'This is the section in which you identify specific high risks that you encountered that may or may not have impacted your sobriety. You identify how you handled them and the success you had. You may also write what you could do to improve.\')"\n        >\n          ?\n        </span>\n      </div>\n\n      <div class="list inline-labels no-hairlines-md">\n        <ul>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-input-wrap">\n                <textarea class="resizable" placeholder="High risks encountered..." id="high-risks">\n';
      r += c(ctx_1.highRisks, ctx_1);
      r += '</textarea\n                >\n              </div>\n            </div>\n          </li>\n        </ul>\n      </div>\n\n      <div class="block-title">\n        Tracking\n        <span\n          class="badge"\n          @click="openHelpSheet(\'Tracking Points\', \'This section allows you to track your progress on a daily basis. It also allows you to track the number of days of sobriety that you have and to keep track of the number of groups that you are attending so you know when you can move onto the next phase. There are approximately 550 points possible per month on the tracking system. We have found that if an individual is working hard and getting 90% or above on a monthly basis, they will be getting better.\')"\n        >\n          ?\n        </span>\n      </div>\n\n      <div class="list inline-labels">\n        <ul>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-title item-label">Pillars</div>\n              <div class="item-input-wrap">\n                <div class="row">\n                  <div class="col-33">\n                    <label class="checkbox">\n                      <input type="checkbox" class="cb-pillar" id="pillar1" @click="setPoints()"\n                      ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.pillar1, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' />\n                      <i class="icon-checkbox"></i>\n                    </label>\n                  </div>\n                  <div class="col-33">\n                    <label class="checkbox">\n                      <input type="checkbox" class="cb-pillar" id="pillar2" @click="setPoints()"\n                      ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.pillar2, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' />\n                      <i class="icon-checkbox"></i>\n                    </label>\n                  </div>\n                  <div class="col-33">\n                    <label class="checkbox">\n                      <input type="checkbox" class="cb-pillar" id="pillar3" @click="setPoints()"\n                      ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.pillar3, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' />\n                      <i class="icon-checkbox"></i>\n                    </label>\n                  </div>\n                  <a href="#" @click="pillarPopup()"\n                    ><i class="icon material-icons color-theme">account_balance</i></a\n                  >\n                </div>\n              </div>\n            </div>\n          </li>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-title item-label">Therapy</div>\n              <div class="item-input-wrap">\n                <p class="segmented segmented-round">\n                  <button\n                    class="button button-round button-outline color-green point-button"\n                    @click="toggle(\'individual\');"\n                    id="toggle-button-individual"\n                    data-points="2"\n                  >\n                    Individual\n                  </button>\n                  <button\n                    class="button button-round button-outline color-green point-button"\n                    @click="toggle(\'group\');"\n                    id="toggle-button-group"\n                    data-points="2"\n                  >\n                    Group\n                  </button>\n                </p>\n              </div>\n            </div>\n          </li>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-title item-label">Homework</div>\n              <div class="item-input-wrap">\n                <label class="checkbox">\n                  <input type="checkbox" id="homework" @click="setPoints()" ';
      r += 'checked';
      r += ' />\n                  <i class="icon-checkbox"></i>\n                </label>\n              </div>\n            </div>\n          </li>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-title item-label">Sobriety</div>\n              <div class="item-input-wrap">\n                <div class="range-slider range-slider-init sobriety-slider" data-label="true">\n                  <input\n                    type="range"\n                    value="0"\n                    min="0"\n                    max="10"\n                    step="1"\n                    id="sobriety-slider"\n                    @change="setPoints()"\n                  />\n                </div>\n              </div>\n            </div>\n          </li>\n          <li class="item-content item-input">\n            <div class="item-inner">\n              <div class="item-title item-label">Acting Out</div>\n              <div class="item-input-wrap">\n                <p class="segmented segmented-round">\n                  <button\n                    class="button button-round button-outline color-red point-button"\n                    @click="toggle(\'mb\');"\n                    id="toggle-button-mb"\n                    data-points="-2"\n                  >\n                    MB\n                  </button>\n                  <button\n                    class="button button-round button-outline color-red point-button"\n                    @click="toggle(\'ao\');"\n                    id="toggle-button-ao"\n                    data-points="-5"\n                  >\n                    AO\n                  </button>\n                </p>\n              </div>\n            </div>\n          </li>\n        </ul>\n      </div>\n\n      <div class="block block-strong">\n        <div class="row">\n          <div class="col-40 text-align-center">\n            Today\'s Points\n            <div class="point-value" id="todays-points">0</div>\n          </div>\n          <div class="col-60 text-align-center">\n            Number of Days Sober\n            <div class="point-value" id="bottom-days-sober">?</div>\n          </div>\n        </div>\n      </div>\n\n      <!-- Delete Button -->\n      <div class="block display-none" id="delete-button-block">\n        <button class="button button-fill button-large color-red" @click="deleteEntry">\n          Delete Entry\n        </button>\n      </div>\n    </div>\n\n    <!-- Info help sheet -->\n    <div class="sheet-modal help-sheet">\n      <div class="toolbar">\n        <div class="toolbar-inner">\n          <div class="left"><div class="title" id="help-title">Info</div></div>\n          <div class="right"><a class="link sheet-close" href="#">Done</a></div>\n        </div>\n      </div>\n      <div class="sheet-modal-inner">\n        <div class="block">\n          <p id="help-text"></p>\n        </div>\n      </div>\n    </div>\n\n    <!-- Pillar Popup -->\n    <div class="popup popup-pillar">\n      <div class="view">\n        <div class="page">\n          <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n              <div class="title pillar-title">Pillar</div>\n              <div class="right">\n                <!-- Link to close popup -->\n                <a class="link pillar-close" @click="pillarClose()">Close</a>\n              </div>\n            </div>\n          </div>\n          <div class="page-content pillar-text text-align-justify">...</div>\n        </div>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
  .block {
    margin: 0;
  }
  .block-title {
    margin-top: var(--f7-block-title-margin-bottom);
  }
  #help-title {
    margin-top: var(--f7-block-title-margin-bottom);
  }
  .point-value {
    font-size: 36pt;
  }
  .pillar-text {
    padding: 60px 20px;
    font-size: 16px;
  }
`,
  styleScoped: false
};
    